import React from 'react';

const HoaTermsConditions = ({ closeModal }) => {
    const handleCloseModalAndNavigate = () => {
        closeModal();
    };

    return (
        <div className="flex justify-center items-center">
            <div className="mx-auto p-5 rounded-md bg-white">
                <h2 className="text-2xl text-center mb-2 text-blue-900">
                    Terms and Conditions
                </h2>
                <h3 className="text-lg mb-2 text-blue-900">
                    Please read the following terms and conditions carefully:
                </h3>
                <p className="text-base leading-6 mb-5 text-blue-900">
                    "By hitting submit, you allow our sales team to contact you"
                </p>
                <div className="flex justify-between">
                    <button
                        className="no-underline px-5 py-2 border-none rounded-md cursor-pointer transition-colors duration-300 bg-blue-900 text-white hover:bg-blue-700"
                        onClick={handleCloseModalAndNavigate}
                    >
                        Agree
                    </button>
                    <button
                        className="no-underline px-5 py-2 border-none rounded-md cursor-pointer transition-colors duration-300 bg-blue-900 text-white hover:bg-blue-700"
                        onClick={handleCloseModalAndNavigate}
                    >
                        Decline
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HoaTermsConditions;